import { internalApi } from "@circle-react/helpers/urlHelpers";

import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";

export interface CanReceiveDmBatchItem {
  can_receive_dm_from_current_member: boolean;
  community_member_id: number;
}

export interface CanReceiveDmBatchResponse extends Array<CanReceiveDmBatchItem> {}

export const fetchCanReceiveDmBatch = (communityMemberIds: number[]) =>
  reactQueryPost<CanReceiveDmBatchResponse>(
    internalApi.communityMembers.batchCanReceiveDm(),
    { community_member_ids: communityMemberIds },
  );
